// ImportanceToggle.jsx - Updated for FM support
import React, { useState, useEffect } from 'react';
import { apiFetch } from '../api/apiClient';

const ImportanceToggle = ({ 
  deviceType, 
  scannerId, 
  itemType, 
  item, 
  isImportant,
  onToggleSuccess
}) => {
  const [loading, setLoading] = useState(false);
  const [optimisticIsImportant, setOptimisticIsImportant] = useState(isImportant);
  
  // Sync with prop changes (e.g., after parent refreshes)
  useEffect(() => {
    setOptimisticIsImportant(isImportant);
  }, [isImportant]);
  
  const handleToggle = async () => {
    // Optimistically update UI immediately
    const newImportantState = !optimisticIsImportant;
    setOptimisticIsImportant(newImportantState);
    setLoading(true);
    
    try {
      let endpoint;
      let payload;
      
      if (deviceType === 'fully_managed') {
        // Use FM-specific endpoints
        if (newImportantState) {
          // Mark important
          endpoint = itemType === 'client' 
            ? '/api/importance/fully-managed/mark-client'
            : '/api/importance/fully-managed/mark-wan';
        } else {
          // Unmark important
          endpoint = itemType === 'client' 
            ? '/api/importance/fully-managed/unmark-client'
            : '/api/importance/fully-managed/unmark-wan';
        }
        
        if (itemType === 'client') {
          payload = {
            serial_number: scannerId,
            mac_address: item.mac || item.mac_address,
            ...(newImportantState ? {
              client_name: item.hostname || item.client_name,
              ip_address: item.ip || item.ip_address
            } : {})
          };
        } else {
          // WAN interface
          payload = {
            serial_number: scannerId,
            ...(newImportantState ? {
              connection_id: item.name || item.interface_name,
              connection_name: item.connection_name || item.name,
              router_ip: item.ip || item.ip_address
            } : {
              interface_name: item.name || item.interface_name
            })
          };
        }
      } else {
        // WM/DC devices
        endpoint = newImportantState 
          ? '/api/monitoring/device/mark-important'
          : '/api/monitoring/device/unmark-important';
        
        payload = {
          serial_number: scannerId,
          device_type: deviceType,
          item_type: itemType,
          item_key: itemType === 'client' ? (item.mac || item.mac_address) : (item.name || item.interface_name),
          ...(newImportantState ? {
            item_name: itemType === 'client' ? (item.hostname || item.client_name) : undefined,
            item_ip: itemType === 'client' ? (item.ip || item.ip_address) : item.ip_address
          } : {})
        };
      }
      
      const response = await apiFetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload)
      });
      
      const result = await response.json();
      
      if (result.success) {
        // Success - trigger parent refresh
        if (onToggleSuccess) {
          onToggleSuccess();
        }
      } else {
        // Revert optimistic update on error
        setOptimisticIsImportant(!newImportantState);
        alert(result.error || 'Failed to update importance');
      }
    } catch (error) {
      console.error('Error toggling importance:', error);
      // Revert optimistic update on error
      setOptimisticIsImportant(!newImportantState);
      alert('Failed to update importance');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="importance-toggle">
      <div 
        className={`toggle-switch ${loading ? 'disabled' : ''}`}
        onClick={handleToggle}
        title={optimisticIsImportant ? 'Mark as Normal' : 'Mark as Important'}
      >
        <div className={`toggle-slider ${optimisticIsImportant ? 'on' : 'off'}`}>
          <div className="toggle-knob">
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportanceToggle;
